import { useRouteMatch } from 'react-router-dom';
import { useMemo } from 'react';
import { useNavbarItems } from './items';
import { useIsExternalNavbarEnabled } from './index';
import {
  NAVBAR_EVENT_METHODS,
  NAVBAR_ITEMS,
  NAVBAR_ITEMS_TO_SUBSCRIBE,
} from '../../constants/navbar';
import { ROOT } from '../../constants/routeTemplates';

const useNavbarItemsToSubscribe = () => {
  const { path } = useRouteMatch();

  const isRootPage = path === ROOT;

  return isRootPage
    ? NAVBAR_ITEMS_TO_SUBSCRIBE
    : [...NAVBAR_ITEMS_TO_SUBSCRIBE, NAVBAR_ITEMS.BACK];
};

const getNavbarSubscribeEvent = (items) => {
  return {
    method: NAVBAR_EVENT_METHODS.SUBSCRIBE,
    payload: items,
  };
};

const getNavbarUpdateEvent = (itemsArray) => {
  const event = {
    method: NAVBAR_EVENT_METHODS.UPDATE,
    payload: {
      itemsConfig: {},
    },
  };

  for (const item of itemsArray) {
    event.payload.itemsConfig[item.item] = item.itemConfig;
  }

  return event;
};

export const useNavbarEvents = () => {
  const isExternalNavbarEnabled = useIsExternalNavbarEnabled();

  const navbarItems = useNavbarItems();
  const itemsToSubscribe = useNavbarItemsToSubscribe();

  const events = useMemo(() => {
    const updateEvent = getNavbarUpdateEvent(navbarItems);
    const subscribeEvent = getNavbarSubscribeEvent(itemsToSubscribe);
    return [updateEvent, subscribeEvent];
  }, [navbarItems, itemsToSubscribe]);

  return !isExternalNavbarEnabled ? [] : events;
};
